import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import bg from "./locales/bg.json";
import en from "./locales/en.json";
import de from "./locales/de.json";

/**
 * Pinned to i18next 21 / react-i18next 11 deliberately: react-scripts 3.4.4 runs Webpack 4,
 * which ignores the `exports` field and does not transpile node_modules. v11 is the last
 * react-i18next without `exports`, and i18next 21 still ships ES5-compatible CJS.
 * Do not upgrade without re-running a production build.
 */
export const LANGUAGES = ["bg", "en", "de"];
export const DEFAULT_LANGUAGE = "bg";
const STORAGE_KEY = "language";

const getInitialLanguage = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (LANGUAGES.includes(stored)) return stored;
  } catch (e) {
    // Private mode / blocked storage — fall through to the default.
  }
  return DEFAULT_LANGUAGE;
};

i18n.use(initReactI18next).init({
  resources: { bg: bg, en: en, de: de },
  lng: getInitialLanguage(),
  fallbackLng: DEFAULT_LANGUAGE,
  ns: [
    "common",
    "auth",
    "validation",
    "app",
    "chat",
    "policies",
    "offers",
    "modals",
    "amarant",
  ],
  defaultNS: "common",
  interpolation: {
    // React already escapes rendered values.
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
  // Surfaces untranslated keys in the console during the migration; see Phase 9.
  saveMissing: process.env.NODE_ENV === "development",
  missingKeyHandler: (lngs, ns, key) => {
    if (process.env.NODE_ENV === "development") {
      console.warn(`[i18n] missing key: ${ns}:${key}`);
    }
  },
});

/**
 * Keep <html lang> in sync with the active language. Screen readers pick voice
 * and pronunciation from it, so a stale value reads English text with Bulgarian
 * phonemes (and vice versa).
 */
const syncHtmlLang = (lng) => {
  document.documentElement.setAttribute("lang", lng);
};
syncHtmlLang(i18n.language);
i18n.on("languageChanged", syncHtmlLang);

// Exposed in dev so the language can be flipped from the console while phases land,
// and so automated checks can assert against the live instance.
if (process.env.NODE_ENV === "development") {
  window.i18n = i18n;
}

export const changeLanguage = (lng) => {
  if (!LANGUAGES.includes(lng)) return;
  try {
    localStorage.setItem(STORAGE_KEY, lng);
  } catch (e) {
    // Non-fatal: the language still applies for this session.
  }
  i18n.changeLanguage(lng);
};

export default i18n;
